export const languagesOptions = [
    { id: 'EN', value: 'EN', key: 'app_locale', label: 'English' },
    { id: 'SV', value: 'SV', key: 'app_locale', label: 'Swedish' },
    { id: 'FI', value: 'FI', key: 'app_locale', label: 'Finnish' },
    { id: 'DA', value: 'DA', key: 'app_locale', label: 'Danish' },
    { id: 'NO', value: 'NO', key: 'app_locale', label: 'Norwegian' },
    { id: 'IS', value: 'IS', key: 'app_locale', label: 'Icelandic' },
];

export const countriesOptions = [
    { id: 'SE', value: 'SE', key: 'country_code', label: 'Sweden' },
    { id: 'FI', value: 'FI', key: 'country_code', label: 'Finland' },
    { id: 'NO', value: 'NO', key: 'country_code', label: 'Norway' },
    { id: 'DK', value: 'DK', key: 'country_code', label: 'Denmark' },
    { id: 'IS', value: 'IS', key: 'country_code', label: 'Iceland' },
];

export const accountTypesOptions = [
    { id: 'SINGLE', value: 'SINGLE', label: 'Single' },
    { id: 'FAMILY', value: 'FAMILY', label: 'Family' },
    { id: 'BUSINESS', value: 'BUSINESS', label: 'Business' },
];
